export const environment = {
  authorization: {
    issuer: 'https://sso.shareview.dev',
    clientId: 'shareview-config',
    scope: 'openid profile offline_access roles shareview',
  },
  apiBaseUrl: 'https://api.shareview.dev',
  appId: 4,
  environment: 'stage',
  applicationInsights: {
    // ai-shareview-dev
    instrumentationKey: '5d9a3c40-466c-4d0b-ade0-518f7293be4b',
  },
};
